import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    EntryOptions,
    PropertyDefinition, PropertyMappingType,
} from "app/library/layout-builder";
import { MetaTypeEnum } from 'app/shared';
import { CorporateTimelineProps } from "./types";
import { ImageChildrenDefinitions } from 'components/cms/definitions';

export class CorporateTimelineDefinitions extends CmsReactComponent<CorporateTimelineProps> {
    static defaultProps = {};

    static schemaName = "corporate-timeline";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "data",
            text: "Yıllar",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: [
                    {
                        name: "title",
                        mapping: {
                            type: PropertyMappingType.String
                        },
                        text: "Başlık"
                    },
                    {
                        name: "content",
                        mapping: {
                            type: PropertyMappingType.Html
                        },
                        text: "İçeriği"
                    },
                    {
                        name: "image",
                        text: "Tarih'e Ait Fotoğraf",
                        description: "İçerikte gözükecek fotoğrafı temsil eder",
                        mapping: {
                            type: PropertyMappingType.ParentObject,
                            children: ImageChildrenDefinitions,
                        }
                    },
                ]
            },
        },
    ];

    static options: EntryOptions = {
        meta: {
            use: true,
            allowedTypes: [],
        },
        mappingFields: [
            {
                name: "title",
                text: "Başlık",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "anchor",
                text: "URL",
                types: [MetaTypeEnum.Link]
            },
        ],
    };
}
